module.exports = __webpack_public_path__ + "media/src/images/logo_highres-9bd74cae6af0ac792b5acc2c2f6260b7.png";